/* tslint:disable */
/* eslint-disable */
/**
 * CAST.AI API documentation
 * ### Feature maturity indicators (may appear on resources, operations and request/response fields)  - **(BETA)** - new or experimental features, subject to change  - **(Deprecated)** - outdated or replaced features (a reason and removal date will be provided in the description) 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * - TYPE_FIXED: Specifies a fixed price discount. If set, the price will be overridden with the value of the discount. For example if the public price is $3 and the discount is \"1\" ($1), the final price will be $1.  - TYPE_PERCENTAGE: Specifies a percentage discount. If set, the price will be reduced by the percentage value. For example if the public price is $5 and the discount value is \"0.1\" (10%), the final price will be $4.  - TYPE_FLAT: Specifies a flat discount. If set, the price will be reduced by the specified value. For example if the public price is $5 and the discount value is \"1\", the final price will be $4. Same if discount value is \"-1\", the final price will be $6.
 * @export
 * @enum {string}
 */

export const CastaiInventoryV1beta1DiscountPricingType = {
    UNKNOWN: 'TYPE_UNKNOWN',
    FIXED: 'TYPE_FIXED',
    PERCENTAGE: 'TYPE_PERCENTAGE',
    FLAT: 'TYPE_FLAT'
} as const;

export type CastaiInventoryV1beta1DiscountPricingType = typeof CastaiInventoryV1beta1DiscountPricingType[keyof typeof CastaiInventoryV1beta1DiscountPricingType];



